export default "/images/3a8f25eafaa63baecefa238f3198eac8.avif";